// The Render Kit components this client can draw, sent with every /api/chat
// request as `ui.renderers`. The server offers a card only when its exact
// `key@version` is listed here, so a build without a renderer never gets one.
// Kept in step with src/render-kit/catalog.mjs by test/render-kit-tools.mjs.
export const RENDERERS = ['email@1', 'email_thread@1', 'email_draft@1'] as const;

/** Tool names whose result is a card, keyed by name like the other standalone tools. */
export const RENDER_TOOL_NAMES: ReadonlySet<string> = new Set([
  'render_email',
  'render_email_thread',
  'render_email_draft',
]);
